"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EarlyPassportSkinFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var EarlyPassportSkinFactory = /** @class */ (function (_super) {
    __extends(EarlyPassportSkinFactory, _super);
    function EarlyPassportSkinFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    EarlyPassportSkinFactory.prototype.deploy = function (_defiPassport, overrides) {
        return _super.prototype.deploy.call(this, _defiPassport, overrides || {});
    };
    EarlyPassportSkinFactory.prototype.getDeployTransaction = function (_defiPassport, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _defiPassport, overrides || {});
    };
    EarlyPassportSkinFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    EarlyPassportSkinFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    EarlyPassportSkinFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return EarlyPassportSkinFactory;
}(contracts_1.ContractFactory));
exports.EarlyPassportSkinFactory = EarlyPassportSkinFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_defiPassport",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "_uri",
                type: "string",
            },
        ],
        name: "BaseURISet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_threshold",
                type: "uint256",
            },
        ],
        name: "PassportIDThresholdSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "baseURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defiPassport",
        outputs: [
            {
                internalType: "contract IERC721Enumerable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "passportIdThreshold",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
        ],
        name: "safeMint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_uri",
                type: "string",
            },
        ],
        name: "setBaseURI",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_threshold",
                type: "uint256",
            },
        ],
        name: "setPassportIdThreshold",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "usersAlreadyMinted",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
